import SchedulerStatusTabs from "./SchedulerStatusTabs";
import {taskStatusOptions} from "./boardConfigs";

export default function TaskStatusTabs({selectedStatus, statusCounts, onChange}) {
    return (
        <SchedulerStatusTabs
            options={taskStatusOptions}
            selectedStatus={selectedStatus}
            statusCounts={statusCounts}
            onChange={onChange}
        />
    );
}
